var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0069 16.0427C19.8424 15.3836 21.3129 13.0767 20.5108 9.12192C20.9752 9.12192 21.8699 8.61276 21.999 6.65099C22.0169 6.37854 21.789 6.15668 21.5167 6.10739C21.0962 6.03129 20.5896 5.85441 20.2482 5.50051C20.065 5.31052 19.8692 5.11447 19.6081 5.065C18.5053 4.85609 16.7065 5.05206 15.9992 7.14455C15.1971 9.51727 14.3282 10.1105 13.994 10.1105C12.4752 10.2602 9.07874 11.118 6.66587 13.3519C6.20231 13.781 5.57117 14.1392 5.00254 13.8586C4.61242 13.6661 4.3575 13.3614 4.19837 13.0417C3.95434 12.5516 3.51929 12.0878 2.96558 12.0878C2.41187 12.0878 1.95691 12.5319 2.00325 13.0761C2.2084 15.485 3.19757 17.0312 4.97075 17.0312H15.9992C16.3663 18.4794 19.0019 18.9332 20.5987 18.9996C20.8273 19.0092 21.0121 18.8257 21.0121 18.6001C21.0121 18.2286 20.8624 17.8724 20.5961 17.6097L19.0069 16.0427ZM19.5 7C19.2239 7 19 6.77614 19 6.5C19 6.22386 19.2239 6 19.5 6C19.7761 6 20 6.22386 20 6.5C20 6.77614 19.7761 7 19.5 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeal);
export default __webpack_public_path__ + "static/media/seal.b9bcd536d2b7a1d0dd3814e4a7b73052.svg";
export { ForwardRef as ReactComponent };